<dx-popup
  [showTitle]="true"
  title="Erreurs lors de la génération du bon de livraison"
  [(visible)]="displayPlatsErrors"
  [height]="'auto'"
  width="auto"
  maxWidth="70%"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (close)="closeErrors()"
>
  <label>Attention : les dates de conditionnements des produits suivants sont postérieures à la date de
    livraison.</label>
  <dx-data-grid
    [dataSource]="printErrors"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showRowLines]="true"
    [showBorders]="true"
    columnResizingMode="widget"
  >
    @if (isMultiPlanProduction) {
      <dxi-column dataField="planProductionLibelle" caption="Plan de production"
                  [allowFiltering]="true"></dxi-column>
    }
    <dxi-column dataField="libelle" caption="Produit"
                [allowFiltering]="true"></dxi-column>
    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} erreur(s)">
    </dxo-pager>
  </dx-data-grid>
  <div class="custom-button-container-right mt-2">
    <yo-button (onClick)="forcePrint()" label="Forcer l'impression" iconClass="fas fa-print"
               [theme]="ButtonThemeEnum.DEFAULT"></yo-button>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="displayConditionnementDateErrorMessage"
  [height]="'auto'"
  width="auto"
  maxWidth="70%"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (close)="closeErrors()"
>
  <div>
    Certaines dates de conditionnement considérées ponctuellement fermées sont à modifier sur votre écran de
    conditionnement afin de mettre à jour votre édition
  </div>
  @if (isMultiPlanProduction && conditionnementDateErrorList?.length) {
    <dx-data-grid
      [dataSource]="conditionnementDateErrorList"
      [hoverStateEnabled]="true"
      [rowAlternationEnabled]="true"
      [allowColumnResizing]="true"
      [showRowLines]="true"
      [showBorders]="true"
      columnResizingMode="widget"
    >
      <dxi-column dataField="planProductionLibelle" caption="Plan de production"
                  [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="pointLivraison.libelle" caption="Point de livraison"
                  [allowEditing]="false"></dxi-column>
      <dxi-column dataField="dateConsommation" caption="Date de consommation" dataType="date"
                  format="dd/MM/yyyy" [allowEditing]="false"></dxi-column>
    </dx-data-grid>
  }
  <div class="custom-button-container-right mt-2">
    <yo-button (onClick)="forcePrint()" label="Forcer l'impression" iconClass="fas fa-print"
               [theme]="ButtonThemeEnum.DEFAULT"></yo-button>
  </div>
</dx-popup>

<dx-popup
  title="Certaines dates de livraison considérées ponctuellement fermées sont à remplacer."
  [(visible)]="displayLivraisonDateErrorList"
  [height]="'auto'"
  width="auto"
  maxWidth="70%"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (close)="closeErrors()"
>
  <div class="d-flex align-items-center mb-4">
    <span class="mg-r-10">Appliquer une date aux lignes sélectionnées :</span>
    <dx-date-box
      type="date"
      displayFormat="dd/MM/yyyy"
      [(value)]="bulkSwitchingDate"
      placeholder="Date de remplacement"
      width="200px"
    ></dx-date-box>
    <yo-button
      class="ml-2"
      (onClick)="applyBulkSwitchingDate()"
      label="Appliquer"
      iconClass="fas fa-calendar-check"
      [theme]="ButtonThemeEnum.DEFAULT"
      [disabled]="!bulkSwitchingDate || !selectedLivraisonDateErrors.length"
    ></yo-button>
  </div>

  <dx-data-grid
    [title]="'livraisons : fermetures ponctuelles'"
    [dataSource]="livraisonDateErrorList"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
    [columnAutoWidth]="true"
    [allowColumnResizing]="true"
    (onSelectionChanged)="onLivraisonErrorSelectionChanged($event)"
  >
    <dxo-editing mode="cell" [allowUpdating]="true" [useIcons]="true"></dxo-editing>
    <dxo-selection
      [selectAllMode]="'allPages'"
      [showCheckBoxesMode]="'always'"
      mode="multiple">
    </dxo-selection>

    @if (isMultiPlanProduction) {
      <dxi-column
        dataField="planProductionLibelle"
        caption="Plan de production"
        [allowEditing]="false"
      ></dxi-column>
    }
    <dxi-column
      dataField="jourLivraisonFerme"
      caption="Jour livraison fermé"
      dataType="date"
      format="dd/MM/yyyy"
      [allowEditing]="false"
    ></dxi-column>
    <dxi-column
      dataField="tournee.libelle"
      caption="Tournée"
      [allowEditing]="false"
    ></dxi-column>
    <dxi-column
      dataField="dateConsommation"
      caption="Date de consommation"
      dataType="date"
      format="dd/MM/yyyy"
      [allowEditing]="false"
    ></dxi-column>
    <dxi-column
      dataField="pointLivraison.libelle"
      caption="Point de livraison"
      [allowEditing]="false"
    ></dxi-column>
    <dxi-column
      dataField="prestation.libelle"
      caption="Prestation"
      [allowEditing]="false"
    ></dxi-column>
    <dxi-column
      dataField="repas.libelle"
      caption="Repas"
      [allowEditing]="false"
    ></dxi-column>
    <dxi-column
      dataField="switchingDate"
      caption="Date de remplacement"
      dataType="date"
      format="dd/MM/yyyy"
    ></dxi-column>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [showInfo]="true"
      infoText="{2} erreur(s)"
    ></dxo-pager>
  </dx-data-grid>

  <div class="custom-button-container-right mt-2">
    <yo-button (onClick)="forcePrint()" label="Forcer l'impression" iconClass="fas fa-print"
               [theme]="ButtonThemeEnum.DEFAULT"></yo-button>
  </div>
</dx-popup>
